import { ProductsQuery } from "@modules/products/queries/ProductsQuery";
import { ProductsServiceInterface } from "@modules/products/services/ProductsServiceInterface";

import { ProductsStateKitQueryWrapper } from "./ProductsStateKitQueryWrapper";
import { ProductsStateKitServiceWrapper } from "./ProductsStateKitServiceWrapper";

export class ProductsStateKit {
    public readonly query: ProductsStateKitQueryWrapper;
    public readonly service: ProductsStateKitServiceWrapper;

    constructor(
        productsQuery: ProductsQuery,
        productsService: ProductsServiceInterface
    ) {
        this.query = new ProductsStateKitQueryWrapper(productsQuery);
        this.service = new ProductsStateKitServiceWrapper(
            productsService,
            productsQuery
        );
    }
}
